import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Brand from '../../../components/Brand';
import Footer from '../../../components/Footer';
import PageSlug from '../../../components/PageSlug';
import SocialShares from '../../../components/SocialShares/SocialShares';
import WhatsappButton from '../../../components/WhatsappButton';
import routeNames from '../../../constants/routeNames';
import { useContent, useLoading } from '../../../hooks/customHooks';
import ReturnToOriginButton from '../../../components/ReturnToOriginButton';

export default function RedeemSuccessPage() {
    const location = useLocation();
    const { content } = useContent();
    const { setLoading } = useLoading();
    const s = content?.pages?.voucher_redeemed?.settings;
    const cServesMultiple = content?.servesMultiple;
    const c = content?.pages?.voucher_redeemed?.content;
    const g = content?.global_settings?.images;
    const showSocials = s?.footer_social;
    const whatsapp = s?.whatsapp;

    useEffect(() => {
        window.scrollTo({ top: 0 });
        setLoading(false);
    }, []);

    return (
        <div className={`page-wrapper ${s?.bg && g?.bg ? 'has-bg' : ''}`}>
            {s?.bg && g?.bg && (
                <div
                    className={`${s?.bg && g?.bg ? 'with-bg' : ''}`}
                    style={{ backgroundImage: s?.bg && g?.bg && `url(${g?.bg})` }}
                ></div>
            )}
            {s?.header && g?.header && <Brand image={g?.header} />}

            <main>
                {s?.logo && g?.logo && (
                    <section className="campaign-logo">
                        <Link to={routeNames.HOME} className="brand-logo">
                            <img className="header-title-image" alt="" src={g?.logo} />
                        </Link>
                    </section>
                )}

                <section
                    className={`main-content ${s?.bg && g?.bg ? 'transparent-container' : ''}`}
                >
                    <PageSlug title={c?.title?.value} />

                    <div className="redeem-instructions" style={{ margin: '0 15px 0 0' }}>
                        <p style={{ marginBottom: '45px' }}>
                            <span
                                dangerouslySetInnerHTML={{ __html: c?.description?.value }}
                            ></span>
                            {cServesMultiple && <span>{location?.state?.serve}</span>}
                        </p>
                    </div>
                    <ReturnToOriginButton url={location?.state?.callbackUrl} />
                    {s?.body && <img className="mb-n mt-n body-img" src={g?.body} alt="" />}
                </section>

                <section
                    className={
                        'transparent-container ' + (!showSocials && !whatsapp ? 'hidden' : '')
                    }
                >
                    {showSocials && <SocialShares></SocialShares>}
                    {whatsapp && <WhatsappButton />}
                </section>

                {s?.footer && (
                    <Footer className={`${s?.bg && g?.bg ? 'transparent-container' : ''}`} />
                )}
            </main>
        </div>
    );
}
